<template>
  <div>
    <el-dialog
        title="Job Description"
        :visible.sync="is_showing_description_editor">

      <el-input v-model="temp_activity.subject.description"></el-input>
      <el-button v-on:click="save_description" style="margin-top:15px;">Save</el-button>

    </el-dialog>
    <el-row>
      <div style="margin-bottom:15px;">
        <span style="margin-right:8px;">Only Show Running or Successful Jobs</span><el-switch active-color="#008000" v-model="only_success"></el-switch>
        <span style="margin-right:3px;margin-left:24px;"><span style="color:black">★</span>&<span style="color:lightgray">☆</span></span><el-switch active-color="black" v-model="only_starred"></el-switch><span style="color:black;margin-left:3px;">★</span>
      </div>
      <el-timeline :reverse="false">
        <el-timeline-item
            v-for="(activity, index) in filtered_table_data"
            :key="index"
            :color="activity.status?activity.status.color:null"
            :size="activity.status&&activity.status.category==='unknown'?'large':'normal'"
            :timestamp="activity.nice_time"
            :icon="activity.status&&activity.status.category==='unknown'?'el-icon-s-promotion':null"
        >
          {{activity.description}}
          <span v-if="activity.properties.extent_name"> on {{activity.properties.extent_name}}</span>
          <span v-if="activity.user_name"> by {{activity.user_name}}</span>
          <span v-if="activity.properties.primary_action==='jobchain'">
                                        (<a :href="'/progress/' + activity.subject_id">Progress status page</a>)
                                    </span>
          <span v-if="activity.status" style="padding:3px;background-color:lightgray">{{activity.status.text}}</span>
          <span @click="toggle(activity.subject_id)" v-if="activity.subject_type ==='App\\JobChain' && activity.subject.starred"><span style="color:black">★</span></span>
          <span @click="toggle(activity.subject_id)" v-else><span style="color:lightgray">☆</span></span>
          <div v-if="activity.properties.primary_action==='jobchain'">
            <span @click="show_description_editor(activity)" v-if="activity.subject.description"><em>{{activity.subject.description}}</em></span>
            <span v-else @click="show_description_editor(activity)" style="font-size:smaller;color:lightgray">Add Description</span>
          </div>
        </el-timeline-item>
      </el-timeline>

    </el-row>
  </div>

</template>

<script>
export default {
  name: "ActivityList",
  props: ['table_data'],
  watch: {
    table_data: function() {
      this.modified_table = this.table_data
    },
  },
  computed: {
    filtered_table_data: function () {
      let filtered = null
      if (this.modified_table) {
        filtered = this.modified_table
        if (this.only_success) {
          filtered = filtered.filter(activity => {
            if (!activity.status) return false;
            return (activity.status.category === 'unknown') || (activity.status.category === 'completed')
          })
        }
        if (this.only_starred) {
          filtered = filtered.filter(activity => {
            if (!activity.status) return false;
            return (activity.subject_type === 'App\\JobChain') && (activity.subject.starred)
          })
        }
      }
      return filtered
    },
  },
  methods: {
    save_description() {
      axios.post("/api/jobChains/description/" + this.temp_activity.subject_id, {
            description: this.temp_activity.subject.description
          })
          .then(response => {
            console.log(response.data)
            this.modified_table = this.modified_table.map(activity => {
              if (activity.subject_id === this.temp_activity.subject_id) activity.subject.description = this.temp_activity.subject.description
              return activity
            })
            this.is_showing_description_editor = false
          })
          .catch(error => {
            console.log("Could not save description")
          })
    },
    show_description_editor(activity) {
      this.temp_activity = {
        subject_id: activity.subject_id,
        subject: {
          description: activity.subject.description
        }
      }
      this.is_showing_description_editor = true
    },
    toggle(job_chain_id) {
      axios.post("/api/jobChains/toggle_star/" + job_chain_id)
          .then(response => {
            console.log(response.data)
            this.modified_table = this.modified_table.map(activity => {
              if (activity.subject_id === job_chain_id) activity.subject.starred = !activity.subject.starred
              return activity
            })
          })
          .catch(error => {
            console.log("Could not toggle")
          })
    },
  },
  data() {
    return {
      only_success: true,
      only_starred: false,
      modified_table: null,
      temp_activity: {
        subject: {
          description: ''
        }
      },
      is_showing_description_editor: false,
    }
  },
}
</script>

<style scoped>

</style>